function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M17.9,3.9c0-0.3-0.2-0.5-0.5-0.5c-2.5-0.4-4.9-1.1-7.2-2.2c-0.1-0.1-0.3-0.1-0.5,0C7.5,2.2,5.1,3,2.6,3.4 c-0.3,0-0.4,0.3-0.5,0.5C2,5.9,2.3,8,3,9.9c0.6,1.5,1.4,2.8,2.5,4c1.2,1.3,2.7,2.3,4.3,3c0.1,0.1,0.3,0.1,0.4,0 c1.6-0.7,3.1-1.7,4.3-3c1.1-1.2,2-2.5,2.5-4C17.7,8,18,5.9,17.9,3.9z M13.3,6.5l-3.9,4.5c-0.1,0.1-0.2,0.2-0.4,0.2h0 c-0.1,0-0.3-0.1-0.4-0.2L6.8,9.4c-0.2-0.2-0.2-0.6,0-0.8c0.2-0.2,0.6-0.2,0.8,0l1.3,1.3l3.5-4.1c0.2-0.2,0.6-0.3,0.8-0.1 C13.4,6,13.5,6.3,13.3,6.5L13.3,6.5L13.3,6.5z"
});

var SvgShieldCheckmark = function SvgShieldCheckmark(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 18",
    style: {
      enableBackground: "new 0 0 20 18"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgShieldCheckmark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/shieldCheckmark.8dad22a4.svg";
export { ForwardRef as ReactComponent };